import script from "./JaManualLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./JaManualLinks.vue?vue&type=script&setup=true&lang=js"

import "./JaManualLinks.vue?vue&type=style&index=0&id=934f624e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-934f624e"]])

export default __exports__